import { render } from "./PackageCard.vue?vue&type=template&id=68d58f70"
import script from "./PackageCard.vue?vue&type=script&lang=js"
export * from "./PackageCard.vue?vue&type=script&lang=js"

import "./PackageCard.vue?vue&type=style&index=0&id=68d58f70&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__